import { TFunction } from 'i18next'
import { z } from 'zod'

export const createOrganizationFormSchema = (t: TFunction) =>
  z.object({
    address: z.string().min(1, {
      message: t('required'),
    }),
    phoneNumber: z.string().min(1, {
      message: t('required'),
    }),
    email: z
      .string()
      .email({ message: t('invalidEmail') })
      .min(5, {
        message: t('required'),
      }),
    taxId: z.string(),
    description: z
      .string()
      .min(1, { message: t('invalidEmail') })
      .max(500, { message: t('desc-max-size') }),
  })
